module.exports = __webpack_public_path__ + "img/cosmetology-badge.1fd49e55.png";